export const formatLargeNumber = (number: number, maximumSignificantDigits?: number) =>
  number.toLocaleString('en-US', {
    maximumSignificantDigits: maximumSignificantDigits || 2,
    notation: 'compact',
    compactDisplay: 'short',
  });
